

import { trackFB, trackGA, trackGTM, trackTT, isMb, getCampaignName, getLocalStorage, setLocalStorage } from '@efe-activity-fe-util/core'
import { ALL_GP_SELECTOR, ALL_IOS_SELECTOR, PANGLE_POPUP, PANGLE_GP_BUTTONS, PANGLE_IOS_BUTTONS, IGNORE_TRIGGER_PANGLE_BUTTONS, PANGLE_BUTTONS } from '../constants/selector'
import { STORAGE_KEY } from '../constants/trackUniqKeys'
import { usePopup } from '../hooks/usePopup'
import { useBackstage } from './backstage'
import { MB_STORE_CONFIG, PC_STORE_CONFIG } from '../libs/gaConfig'
import { omit } from '../utils/object'

const { getActivityConfig } = useBackstage()

const { openPopup, closePopupAll } = usePopup()

let _openIosPangle = false
let _openAndPangle = false

function gpStoreTrack() {
    
    trackGTM({
        once: true,
        storageKey: STORAGE_KEY.GTM_GP,
        data: {
            send_to: 'AW-18128941059/pj6pCM6tqqgcEIPgxsRD',
            value: 1.0,
            currency: 'USD',
        },
    })
    

    
}

function iosStoreTrack() {
    
    trackGTM({
        once: true,
        storageKey: STORAGE_KEY.GTM_IOS,
        data: {
            send_to: 'AW-18128941059/fNdeCK2tqqgcEIPgxsRD',
            value: 2.0,
            currency: 'USD',
        },
    })
    

    

    zafIosStoreTrack()
    seedappIosStoreTrack()
}

function zafIosStoreTrack() {
    
    if (getLocalStorage(STORAGE_KEY.ZAF_IOS)) {
        return
    }

    $('body').append('<script id="zafscript" src="https://get.mobu.jp.eimg.jp/js/conv/conv.min.js?actcd=d292eb40bf1468a744dbe005e0a47ab2"></script>')
    setLocalStorage(STORAGE_KEY.ZAF_IOS, '1')
    
}

function seedappIosStoreTrack() {
    
    if (getLocalStorage(STORAGE_KEY.SEEDAPP_IOS)) {
        return
    }

    $('body').append('<span id="a8sales"></span><script src="//statics.a8.net/a8sales/a8sales.js"></script><script>a8sales({pid:"s00000020278142",order_number:"1",currency:"JPY",items:[{code:"1",price:1,quantity:1}],total_price:1});</script>')
    setLocalStorage(STORAGE_KEY.SEEDAPP_IOS, '1')
    
}

function allStoreTrack(ttEvent: 'Subscribe' | 'ClickButton' = 'ClickButton') {
    
    trackFB({
        once: true,
        storageKey: STORAGE_KEY.FB_SHOP,
        event: 'Subscribe',
        data: { currency: 'USD', value: 0.0 },
    })
    

    
    trackTT({
        once: true,
        storageKey: STORAGE_KEY.TT_SHOP,
        event: ttEvent,
    })
    
}

function openPanglePopup() {
    closePopupAll()
    openPopup(PANGLE_POPUP)
}



export async function storeTrack() {


    try {
        const activityConfig = await getActivityConfig()
        const { openIosPangle = false, openAndPangle = false } = activityConfig?.activityMsgConfig?.activityMsg?.context ?? {}
        _openIosPangle = openIosPangle
        _openAndPangle = openAndPangle
    } finally {
        const isAndPangle = _openAndPangle && isAndPangleChannel()
        const isIosPangle = _openIosPangle && isIosPangleChannel()

        if (isAndPangle) {
            $(PANGLE_GP_BUTTONS).on('click', () => {
                closePopupAll()
            })
        }

        if (isIosPangle) {
            $(PANGLE_IOS_BUTTONS).on('click', () => {
                closePopupAll()
            })
        }

        listenStoreTrack(isAndPangle, isIosPangle)
    }
    
}

function listenStoreTrack(isAndPangle: boolean, isIosPangle: boolean) {
    const storeConfig = isMb() ? MB_STORE_CONFIG : PC_STORE_CONFIG

    if (!isAndPangle && !isIosPangle) {
        storeConfig.forEach(({ selector, parentDom, ...options }) => {
            if (parentDom) {
                $(parentDom).on('click', selector, () => trackGA(options))
            } else {
                $(selector).on('click', () => trackGA(options))
            }
        })
    }

    $(document).on('click', ALL_GP_SELECTOR, (e) => {
        const $target = $(e.target)
        const ignored =
            $target.closest(IGNORE_TRIGGER_PANGLE_BUTTONS).length > 0

        if (!ignored && isAndPangle) {
            const triggedGaConfig =
                storeConfig.find(
                    ({ selector }) => $target.closest(selector).length > 0
                ) ?? null
            $(PANGLE_BUTTONS).data('gaConfig', triggedGaConfig)
            e.preventDefault()
            openPanglePopup()
        } else {
            gpStoreTrack()
            allStoreTrack()
        }
    })

    $(document).on('click', ALL_IOS_SELECTOR, (e) => {
        const $target = $(e.target)
        const ignored =
            $target.closest(IGNORE_TRIGGER_PANGLE_BUTTONS).length > 0

        if (!ignored && isIosPangle) {
            const triggedGaConfig =
                storeConfig.find(
                    ({ selector }) => $target.closest(selector).length > 0
                ) ?? null
            $(PANGLE_BUTTONS).data('gaConfig', triggedGaConfig)
            e.preventDefault()
            openPanglePopup()
        } else {
            iosStoreTrack()
            allStoreTrack()
        }
    })

    $(PANGLE_BUTTONS).on('click', (e) => {
        const { type = 'gp', gaConfig = null } = $(PANGLE_BUTTONS).data()
        const storeTrackGTM = type === 'gp' ? gpStoreTrack : iosStoreTrack

        storeTrackGTM()
        allStoreTrack('Subscribe')

        if (gaConfig) {
            trackGA(
                omit(gaConfig, ['parentDom', 'selector']) as Parameters<
                    typeof trackGA
                >[0]
            )
        }
    })
}

export function isOpenIosPangle() {
    return _openIosPangle && isIosPangleChannel()
}

export function isOpenAndPangle() {
    return _openAndPangle && isAndPangleChannel()
}

export function isIosPangleChannel() {
    const params = getCampaignName()
    return ["^(?:[^_]*_){7}(ios-pangle|all-all|ios-all)(?:_|$).*"].some((r) => new RegExp(r).test(params))
}

export function isAndPangleChannel() {
    const params = getCampaignName()
    return ["^(?:[^_]*_){7}(and-pangle|all-all|and-all)(?:_|$).*"].some((r) => new RegExp(r).test(params))
}
